{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/button';
import statelyDocs from 'docs:@react-stately/toggle';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a toggle button.';
export const isSubpage = true;

# useToggleButton

<PageDescription>{docs.exports.useToggleButton.description}</PageDescription>

```tsx render files={["starters/hooks/src/ToggleButton.tsx", "starters/hooks/src/ToggleButton.css"]}
"use client";
import {ToggleButton} from 'hooks-starter/ToggleButton';

<ToggleButton>Pin</ToggleButton>
```

## API

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useToggleState, links: statelyDocs.links},
    {function: docs.exports.useToggleButton, links: docs.links},
  ]}
/>

### ToggleState

<InterfaceType {...statelyDocs.exports.ToggleState} links={statelyDocs.links} />

### AriaToggleButtonProps

<InterfaceType {...docs.exports.AriaToggleButtonProps} />
